import * as locationApi from '@/api/location/index';
import store from '@/store';
import * as mt from '@/store/location/mutation-types';
import { LocationDelegate, LocationState, toStateKey } from '@/store/location/types';
import { City, CityRequest, emptyCountryDTO } from '@/api/location/types';

const locationDelegate = {
 fetchStatesByCountry: fetchStates,
 fetchCitiesByCountryAndState: fetchCities,
} as LocationDelegate;

store.dispatch(`location/${mt.SETUP}`, locationDelegate);

export function clearLocation() {
  store.dispatch(`location/${mt.CLEAR}`);
}

export function selectCountry(country: string) {
  store.dispatch(`location/${mt.SELECT_COUNTRY}`, country);
}

export function fetchCountries() {
  store.dispatch(`location/${mt.FETCHING_COUNTRIES}`);
  setTimeout(() => {
    store.dispatch(`location/${mt.FETCH_COUNTRIES}`, ['BRA']);
  }, 0);
}

export function selectState(state: string) {
  store.dispatch(`location/${mt.SELECT_STATE}`, state);
}

async function fetchStates(country: string) {
  store.dispatch(`location/${mt.FETCHING_STATES}`);
  if (!country) {
    store.dispatch(`location/${mt.FETCH_STATES}`, emptyCountryDTO());
  } else {
    const storeCache = ((store.state as any).location as LocationState).states.get(country);
    if (!!storeCache) {
      store.dispatch(`location/${mt.FETCH_STATES}`, storeCache);
    } else {
      try {
        const countryDTO = (await locationApi.getStatesByCountry(country)).data;
        store.dispatch(`location/${mt.FETCH_STATES}`, countryDTO);
      } catch (error) {}
    }
  }
  
}

export function selectCity(city: City) {
  store.dispatch(`location/${mt.SELECT_CITY}`, city);
}

async function fetchCities(country: string, state: string) {
  store.dispatch(`location/${mt.FETCHING_CITIES}`);
  if (!country || !state) {
    store.dispatch(`location/${mt.FETCH_CITIES}`, { country, state, cities: [] });
  } else {
    const storeCache = ((store.state as any).location as LocationState).cities.get(toStateKey(country, state));
    if (!!storeCache) {
      store.dispatch(`location/${mt.FETCH_CITIES}`, { country, state, cities: storeCache });
    } else {
      try {
        const cities = (await locationApi.getCitiesByCountryAndState(country, state)).data;
        store.dispatch(`location/${mt.FETCH_CITIES}`, { country, state, cities });
      } catch (error) {}
    }
  }
}

export async function fetchCityByCentroid(cityRequest: CityRequest) {
  await store.dispatch(`location/${mt.FETCHING_CITY_CENTROID}`);
  try {
    const cityDTO = (await locationApi.findCityByCentroid(cityRequest)).data;
    await store.dispatch(`location/${mt.FETCH_CITY_CENTROID}`, cityDTO);
  } catch (error) {}
}
